import { IconPropTypes } from '@/legacy/types';

const CrownIcon = (props: IconPropTypes) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={props.width || 17}
			height={props.height || 13}
			viewBox='0 0 17 13'
			fill='none'
			{...props}
		>
			<path
				d='M8.06197 0C8.34022 0 8.60651 0.121055 8.78951 0.331055L11.7856 3.76562L14.646 1.95996C14.9662 1.75825 15.3744 1.76226 15.6909 1.9707C16.0073 2.17916 16.1726 2.55357 16.1127 2.92773L14.7534 11.4199C14.6474 12.0825 14.0759 12.5701 13.4057 12.5703H2.71919C2.04886 12.5703 1.47646 12.0827 1.37056 11.4199L0.0121621 2.92773C-0.0477247 2.55369 0.116851 2.17921 0.433061 1.9707C0.749561 1.7622 1.15871 1.75821 1.47896 1.95996L4.33833 3.76562L7.3354 0.331055C7.51834 0.121133 7.78383 8.99262e-05 8.06197 0ZM2.24458 9.75684L2.48189 11.2422C2.50083 11.3589 2.60089 11.4453 2.71919 11.4453H13.4057C13.5239 11.4451 13.6241 11.3588 13.643 11.2422L13.8803 9.75684H2.24458ZM5.09615 4.60938C4.7834 4.96712 4.25596 5.04429 3.85396 4.79004L1.17915 3.10156L2.06392 8.63184H14.061L14.9458 3.10156L12.271 4.79004C11.869 5.04428 11.3415 4.96709 11.0288 4.60938L8.06197 1.20898L5.09615 4.60938Z'
				fill={props.color || 'currentColor'}
			/>
		</svg>
	);
};

export default CrownIcon;
